document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.footer-col').forEach(el => {
		if (!el.querySelector('.collapsed-mobile')) {
			el.classList.add('footer-col--no-collapsed');
		}
		el.querySelectorAll('.menu-label').forEach(label => label.closest('a')?.style.setProperty('--label-width', label.offsetWidth + 'px'));
	})
	document.querySelectorAll('.footer-list-title').forEach(el => {
		el.addEventListener('click', function (e) {
			e.preventDefault();
			this.closest('.collapsed-mobile').classList.toggle('open');
		})
	})
})


function fixFooter() {
  const vv = window.visualViewport;
  const footer = document.querySelector('.fixed-footer');
 
 // footer.style.transform = translateY(${window.innerHeight - vv.height}px);
  //footer.style.transform = 'translateY(' + (window.innerHeight - vv.height) + 'px)';
}
 
visualViewport.addEventListener("resize", fixFooter);
visualViewport.addEventListener("scroll", fixFooter);
